<template>
  <div>
    <b-row class="content-header">
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="12"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title">
              Editing {{ needType.needType }}
            </h1>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-form @submit.prevent="submitForm">
      <validation-observer
        ref="needTypeEditForm"
        #default="{invalid}"
      >
        <b-card header-tag="header">
          <b-row>
            <b-col md="12">
              <validation-provider
                #default="{ errors }"
                name="Available to Agents"
                vid="availableToAgents"
                rules="required"
              >
                <b-form-group
                  label="Available to Agents*"
                  label-for="availableToAgents"
                  label-cols-md="3"
                  :state="errors.length > 0 ? false : null"
                >
                  <v-select
                    id="availableToAgents"
                    v-model="availableToAgents"
                    :options="availableOptions"
                    :reduce="opt => opt.value"
                    label="label"
                    :clearable="false"
                    placeholder="Select..."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="12">
              <b-form-group
                label="Display Label"
                label-cols-md="3"
                label-for="displayLabel"
              >
                <b-form-input
                  id="displayLabel"
                  v-model="displayLabel"
                  placeholder=""
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>

        <b-nav class="wrap-border save-nav">
          <li class="nav-item">
            <span>You're currently editing a core product. Please save to avoid losing your data.</span>
          </li>
          <li class="nav-item ml-auto">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="button"
              variant="flat-primary"
              @click="cancelRedirect"
            >
              Cancel
            </b-button>
          </li>
          <li class="nav-item mr-1">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="success"
              :disabled="invalid"
            >
              <feather-icon
                icon="SaveIcon"
                class="mr-50"
              />
              <span class="align-middle">Save Changes</span>
            </b-button>
          </li>
        </b-nav>
      </validation-observer>
    </b-form>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BNav,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { required } from '@validations'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BNav,
    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      needType: {},
      codeId: null,
      availableToAgents: null,
      displayLabel: '',
      availableOptions: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
      ],
      required,
    }
  },
  created() {
    this.$http.get(`reservation/product-need-type/${this.$route.params.id}`)
      .then(response => {
        this.needType = response.data
        this.codeId = this.needType.productCode ? this.needType.productCode._id : null
        this.availableToAgents = this.needType.availableToAgents ? 'yes' : 'no'
        this.displayLabel = this.needType.displayLabel || ''

        store.commit('breadcrumb/REMOVE_BREADCRUMB')
        store.commit('breadcrumb/UPDATE_BREADCRUMB', {
          text: this.needType.productCode ? this.needType.productCode.name : 'Product Code',
          to: `/products/codes/${this.codeId}/show`,
        })
        store.commit('breadcrumb/UPDATE_BREADCRUMB', {
          active: true,
          text: `Editing ${this.needType.needType}`,
        })
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  },
  methods: {
    cancelRedirect() {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.push({ name: 'products-codes-index' })
      }
    },
    submitForm() {
      this.$refs.needTypeEditForm.validate().then(success => {
        if (success) {
          const formData = new FormData()
          formData.append('availableToAgents', this.availableToAgents)
          formData.append('displayLabel', this.displayLabel)

          this.$http.patch(`reservation/product-need-type/${this.$route.params.id}/update`, formData)
            .then(() => {
              this.$swal({
                title: 'Need Type Updated',
                html: '',
                // eslint-disable-next-line global-require
                imageUrl: require('@/assets/images/icons/success.png'),
                imageWidth: 80,
                imageHeight: 80,
                imageAlt: 'Custom Icon',
                showCancelButton: false,
                confirmButtonText: 'Okay',
                customClass: {
                  confirmButton: 'btn btn-primary mt-1',
                },
                buttonsStyling: false,
              })
                .then(result => {
                  if (result.value) {
                    if (window.history.length > 1) {
                      this.$router.back()
                    } else {
                      this.$router.push({ name: 'products-codes-index' })
                    }
                  }
                })
            })
            .catch(error => {
              if (error.data.errors) {
                error.data.errors.forEach(validationError => {
                  if (validationError.param === 'availableToAgents') {
                    this.$refs.needTypeEditForm.setErrors({ availableToAgents: [validationError.msg] })
                  }
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            })
        }
      })
    },
  },
}
</script>
